import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'
import { useInView } from 'react-intersection-observer'
import { Phone, Mail, Shield, Sparkles } from 'lucide-react'

export const CTASection = () => {
  const [ref, inView] = useInView({
    threshold: 0.2,
    triggerOnce: true,
  })

  return (
    <section ref={ref} className="py-24 relative">
      {/* Background is global in Home.tsx */}
      <div className="container-enterprise relative z-10">
        <div className="max-w-4xl mx-auto">
          {/* Content */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.5 }}
            className="text-center"
          >
            {/* Badge */}
            <motion.div
              initial={{ opacity: 0, scale: 0.8 }}
              animate={inView ? { opacity: 1, scale: 1 } : {}}
              transition={{ duration: 0.3 }}
              className="inline-flex items-center gap-2 px-4 py-2 rounded-full mb-6"
              style={{
                background: 'linear-gradient(135deg, rgba(99, 102, 241, 0.2) 0%, rgba(139, 92, 246, 0.2) 100%)',
                border: '1px solid rgba(99, 102, 241, 0.3)',
              }}
            >
              <Shield className="w-4 h-4 text-primary" />
              <span className="text-sm text-slate-300">ISO Certified Excellence</span>
            </motion.div>

            {/* Title */}
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-6">
              Ready to Transform
              <br />
              <span className="gradient-text">Your Organization?</span>
            </h2>

            {/* Description */}
            <p className="text-lg text-slate-400 mb-10 max-w-2xl mx-auto">
              Partner with a trusted government technology provider. Let's discuss how we can help you achieve your digital transformation goals.
            </p>

            {/* Dual CTAs */}
            <div className="flex flex-wrap items-center justify-center gap-4 mb-12">
              <Link
                to="/contact"
                className="btn-glow inline-flex items-center gap-2 px-8 py-4 text-white font-semibold"
              >
                <Sparkles className="w-5 h-5" />
                <span>Start Your Project</span>
              </Link>
              <a
                href="tel:+918390101555"
                className="btn-secondary inline-flex items-center gap-2 px-8 py-4 text-white font-semibold rounded-2xl"
              >
                <Phone className="w-5 h-5" />
                <span>Call Us</span>
              </a>
            </div>

            {/* Contact Info */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.5, delay: 0.2 }}
              className="flex flex-wrap justify-center gap-8"
            >
              <a href="tel:+918390101555" className="flex items-center gap-2 text-slate-400 hover:text-white transition-colors">
                <Phone className="w-5 h-5" />
                <span>+91 8390101555</span>
              </a>
              <a href="mailto:info@eonixa.in" className="flex items-center gap-2 text-slate-400 hover:text-white transition-colors">
                <Mail className="w-5 h-5" />
                <span>info@eonixa.in</span>
              </a>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>
  )
}